import React, { useEffect, useMemo, useState } from "react";
import { Divider } from "@mui/material";

import ListItem from "./components/listItem";
import useTheme, { ThemeContext } from "./hooks/useTheme";
import useWindowDimensions from "./hooks/useWindowDimensions";
import useApi from "./apis/useApi";
import { AppInfoType, FilterType, SupportedType } from "./types/types";
import ListHeader from "./components/listHeader";
import Header from "./components/header";
//import Switch from "./components/Switch";

import "./App.css";
import NoAppsInfo from "./components/NoAppsInfo";

const getCurrentTheme = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export default function App() {
  const [theme] = useState(getCurrentTheme() === true ? "dark" : "light");

  const { isSmallLayout, isMediumLayout } = useWindowDimensions();
  const colorScheme = useTheme();

  const [data, setData] = useState<AppInfoType[]>([]);
  const [filter, setFilter] = useState<FilterType>({
    erp: undefined,
    platform: undefined,
  });

  const displayData = useMemo(
    () =>
      data
        ?.filter((element: AppInfoType) => {
          if (filter.erp === undefined) return element;
          return element.erp.includes(filter.erp);
        })
        ?.filter((element: AppInfoType) => {
          if (filter.platform === undefined) return element;
          return !!element.supportedPlatforms.find(
            (s: SupportedType) => s.platform === filter.platform
          );
        })
        ?.sort((a, b) => (a.app > b.app ? 1 : b.app > a.app ? -1 : 0)),
    [data, filter]
  );

  useEffect(() => {
    //fetch data
    useApi
      .getRequirements()
      .then((result: AppInfoType[]) => setData(result))
      .catch((error) => console.error("error getRequirements:", error));
  }, []);

  return (
    <ThemeContext.Provider value={theme}>
      <div style={{ background: colorScheme.background }}>
        {/* <Switch
          isOn={theme === "dark"}
          onColor="black"
          handleToggle={() => setTheme(theme === "dark" ? "light" : "dark")}
        ></Switch> */}

        <Header filter={filter} setFilter={setFilter} />
        {isSmallLayout || isMediumLayout ? (
          <Divider variant="middle" sx={{ borderColor: colorScheme.divider }} />
        ) : (
          <ListHeader />
        )}
        {displayData.length === 0 ? (
          <NoAppsInfo />
        ) : (
          displayData?.map((appInfo: AppInfoType) => {
            return (
              <div key={appInfo.app}>
                <ListItem
                  logo={appInfo.icon}
                  name={appInfo.app}
                  note={appInfo.note}
                  platforms={appInfo.supportedPlatforms}
                  devices={appInfo.supportedDevices}
                  erp={appInfo.erp}
                  authentication={appInfo.authentication}
                />
                <Divider
                  variant="middle"
                  sx={{
                    borderColor: colorScheme.divider,
                  }}
                />
              </div>
            );
          })
        )}

        {/* <Container>
          <div className="ratio ratio-16x9">
            <iframe
              src="https://www.youtube.com/embed/aTgwqmZ_MOo"
              title="Information about Ergo Mobile Time"
              allowFullScreen
            ></iframe>
          </div>
        </Container> */}
      </div>
    </ThemeContext.Provider>
  );
}
